import { css as className } from "@emotion/css";
import { css } from "@emotion/react";
import { Colors, Spacing } from "@snapchat/snap-design-system";

// eslint-disable-next-line max-len
// https://github.sc-corp.net/Snapchat/snap-design-system/blob/048b212b3132e8c3454f9403dcacbae2a02226c6/packages/snap-design-system/src/components/NavBar/styles.ts#L16
const NAV_BAR_HEIGHT = "54px";

export const leftContentStyle = css`
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    width: 300px;
    padding-left: ${Spacing.XL}px;

    @media (max-width: 768px) {
        width: unset;
    }

    @media (max-width: 899px) {
        padding-left: 0;
    }
`;

export const globalNav = css`
    display: none;

    @media (max-width: 899px) {
        display: block;
    }
`;

export const drawerClassName = className`
    .drawer-open {
        top: ${NAV_BAR_HEIGHT};
    }

    .drawer-left {
        top: ${NAV_BAR_HEIGHT};
    }

    .sds-drawer-container {
        height: calc(100% - ${NAV_BAR_HEIGHT});
    }
`;

export const titleStyle = css`
    margin-left: 16px;
`;

export const barsIconStyle = css`
    padding-left: 0px !important;
`;

export const docsLinkStyle = css`
    display: inline-flex;
    align-items: center;
    color: ${Colors.Black.V100};
    font-size: 16px;
    padding: ${Spacing.SM}px ${Spacing["2XS"]}px;
    margin-top: ${Spacing.SM}px;
    width: 100%;

    :hover {
        background-color: #f7f8f9;
        border-radius: 4px;
        color: inherit;
    }

    ::after {
        background-color: ${Colors.Black.V100};
    }
`;

// !important is needed here since it gets overwritten by the sds styling
export const drawerListItemClassName = className`
    font-weight: 400 !important;
    font-size: 16px !important;
    line-height: 28px !important;
    > div {
        padding: 6px;
    }
`;
